import clsx from "clsx";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { To, useLocation } from "react-router";
import Card from "../card";
import Collapse from "../collapse";
import OverlayTrigger from "../overlaytrigger";
import { useDrawerContext } from "./drawer";
import DrawerItem from "./drawerItem";

export interface DrawerGroupProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: React.FC<any>;
  title: React.ReactNode;
  children?: React.ReactNode;
  to?: To;
}

export default function DrawerGroup(props: Readonly<DrawerGroupProps>) {
  const { className, icon, title, children, to, ...rest } = props;
  const { pathname } = useLocation();

  const isActive =
    !!to && pathname.includes(typeof to === "string" ? to : to.pathname || "");

  const { open: drawerOpen, variant, float } = useDrawerContext();
  const [open, setOpen] = useState(isActive);

  return (
    <div {...rest}>
      {!drawerOpen && !float && (
        <OverlayTrigger
          trigger={["focus", "click"]}
          placement="right"
          overlay={
            <Card
              className={clsx("p-2", {
                "bg-primary-light": variant === "light",
                "bg-primary": variant === "colored",
                "bg-secondary-dark": variant === "dark",
              })}
            >
              {children}
            </Card>
          }
        >
          <button>
            <DrawerItem
              icon={icon}
              title={title}
              isActive={!drawerOpen && isActive}
            />
          </button>
        </OverlayTrigger>
      )}
      {(drawerOpen || float) && (
        <>
          <DrawerItem
            icon={icon}
            title={title}
            onClick={() => setOpen((state) => !state)}
          >
            <ChevronDown
              size="16"
              className={clsx("transition-transform", {
                "rotate-180": open || isActive,
              })}
            />
          </DrawerItem>
          <Collapse in={open || isActive}>
            <div>{children}</div>
          </Collapse>
        </>
      )}
    </div>
  );
}
